import { BooleanField, Datagrid, FunctionField, InfiniteList, NumberField, TextField, TopToolbar, useRefresh, useTranslate } from "react-admin"
import { ReverseInvoiceReadModel } from "../GeneratedClients/FreeBillApi"
import { HubConnection } from "@microsoft/signalr"

interface IProps {
  connection?: HubConnection
}

const ReverseInvoiceList = ({connection} : IProps) => {
  
  const refresh = useRefresh()
  connection?.on('ReverseInvoiceUpdated', () => { refresh() })
  const translate = useTranslate()

  return (
    <InfiniteList actions={<TopToolbar />} sort={{field: "createdAt", order: "DESC"}} >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="textModel.heading" label='resources.reverseInvoices.heading'  sortable={false} />
        <TextField source="invoiceRecipient.company.companyName" label={'resources.company.companyName'} sortable={false} />
        <BooleanField source="isSendByMail" label='resources.reverseInvoices.isSendByMail' sortable={false} />
        <FunctionField 
          label='resources.reverseInvoices.isBooked' 
          sortable={false} 
          render={(reverseInvoice: ReverseInvoiceReadModel) => <BooleanField record={{isBooked: reverseInvoice.bookingInfos !== null}} source="isBooked" />}
        />
        <NumberField label={translate("resources.invoices.comment", {smart_count: 2})} source="comments.length" emptyText="0" sortable={false} />
      </Datagrid>
    </InfiniteList>
  )
}

export default ReverseInvoiceList